import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LibApiBaseService, LibHttpErrorHandler } from 'ngx-mat-base-comp';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends LibApiBaseService<any> {
    constructor(
      http: HttpClient,
      httpErrorHandler: LibHttpErrorHandler,
      ) {
      super(
        http,
        httpErrorHandler,
        environment.baseURLHubAPI,
        'Document'
      );
    }
  }